import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from 'app/shared/app-features/models/features.enum';

@Injectable()
export class EnableCalculationAvailabilityDateForModify implements IFlagFeature {
  name = Features.ENABLE_CALCULATION_AVAILABILITY_DATE_FOR_MODIFY;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
